export default "__VITE_ASSET__D1u3Ny3W__"